<template>
  <v-layout justify-center>

    <loading :active.sync="busy"/>

    <v-dialog v-model="dialog_status" class="dialog-container"
      scrollable max-width="400px">

      <v-card>

        <v-card-title class="card-title-wrapper">
          <span class="card-title">{{ $t('create_project.start_project') }}</span>
          <v-btn icon @click="close()"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="card-text-wrapper">
          <v-flex xs12>
            <div>
              <span class="card-text">{{ $t('create_project.title') }}</span>
              <span class="required">*</span>
            </div>
            <v-text-field outlined dense
              :disabled="busy"
              color="#dde2e5"
              v-model.trim.lazy="title"
              @input="resetError()"
              @blur="$v.title.$touch();checkTitle()"
              :error-messages="title_errors">
            </v-text-field>
          </v-flex>

          <v-flex xs12>
            <div>
              <span class="card-text">{{ $t('create_project.description') }}</span>
            </div>
            <v-textarea outlined
              :disabled="busy"
              color="#dde2e5"
              v-model="description"
              @input="resetError()">
            </v-textarea>
          </v-flex>

          <!-- <v-flex xs12>
            <div class="sub-title">{{ $t('create_project.view_mode') }}</div>
            <v-radio-group class="small-radio"
              v-model="mode" row
              @input="resetError()">
              <v-radio v-for="(value, key) in project_mode"
                :key="key"
                :value="parseInt(key)">
                <template v-slot:label>
                  {{ $t('create_project.'+value.code) }}
                </template>
              </v-radio>
            </v-radio-group>
          </v-flex> -->

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed block dark color="#ff5193"
            :disabled="busy"
            @click="createProject(1)">
            {{ $t('create_project.start_now') }}
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </v-layout>

</template>

<script>
  import { project_mode } from '../../../custom/model'
  import { mapGetters } from 'vuex'
  import { required } from 'vuelidate/lib/validators'
  
  export default {
    props: {
      dialog: Boolean,
    },

    data() {
      return {
        busy: false,

        title: "",
        description: "",
        is_duplicated: false,

        project_mode: project_mode,
        mode: 0,
        list_mode: 20,
      }
    },

    computed: {
      dialog_status: {
        get: function(value) {
          return this.dialog
        },
        set: function(value) {
          if (!value) { this.close() }
        },
      },

      ...mapGetters({
        projects: 'project/projects',
      }),

      project_title_list() {
        return this.projects.map(proj => proj.title)
      },

      title_errors() {
        const errors = []
        if (!this.$v.title.$dirty) return errors
        !this.$v.title.required && errors.push(this.$t('create_project.required'))
        !this.$v.title.isUnique && errors.push(this.$t('create_project.available'))
        return errors
      },
    },

    validations: {
      title: {
        required,
        isUnique() {
          return this.$v.title.$dirty &&
            this.$v.title.required &&
            !this.is_duplicated
        }
      },
    },

    methods: {
      checkTitle() {
        if(this.project_title_list.includes(this.title)) {
            this.is_duplicated = true
          } else { this.is_duplicated = false }
      },

      async createProject(status) {
        this.busy = true
        this.$v.title.$touch()
        if (!this.$v.title.$anyError) {
          let error = false
          try {
            await this.$store.dispatch('project/createProject', {
              title: this.title,
              description: this.description,
              mode: this.mode,
              list_mode: this.list_mode,
            })
          } 
          catch(e) {
            this.$store.commit('error/setDialog', true)
            this.$store.commit('error/setErrorCode', e.response.status)
            error = true
          } 
          finally {
            if (!error) {
              let new_proj_id = this.$store.getters['project/new_proj_id']
              try {
                if (status != 1) {
                  await this.$store.dispatch('project/updateProject', {
                    proj_id: new_proj_id,
                    status,
                  })
                }
              } catch(e) {
                this.$store.commit('error/setDialog', true)
                this.$store.commit('error/setErrorCode', e.response.status)
                error = true
              } finally {
                if (!error) {
                  this.$router.push({name: 'project', params: {id: this.$store.getters['project/new_proj_id']}})
                }
              }
            }
            setTimeout(() => {
              this.busy = false
            }, 500)
          }
        }
      },

      close() {
        this.$v.$reset()
        this.title = ""
        this.description = ""
        this.mode = 0
        this.is_duplicated = false
        this.$emit('update:dialog', false)
      },

      resetError() {
        this.$v.$reset()
        this.is_duplicated = false
      },
    }
  }
</script>

<style scoped>
  .card-title-wrapper {
    height: 50px;
    padding: 0 24px !important;
    border-bottom: 1px solid #dde2e5;
    display: flex;
    justify-content: space-between;
  }

  .card-title {
    font-size: 16px;
    font-weight: bolder;
  }

  .card-text-wrapper {
    margin-top: 20px;
  }

  .card-text {
    color: #485158;
  }

  .sub-title {
    padding-bottom: 5px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/project/CreateProject.vue